import { Box, Paper, Tabs, Tab } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import Container from "src/layout/Container";
import TabPanel from "src/utils/TabPanel";
import ImagingTest from "./test/ImagingTest";
import ImagingSales from "./sales/sales";
import TestPerson from "./test-person";

const AccountingImaging = () => {
  const [category, setCategory] = useState("test-person");
  const handleChange = (event, xcat) => {
    setCategory(xcat);
  };

  return (
    <Container
      breadcrumbs={{
        enable: true,
        current: "Imaging",
        items: [{ name: "Dashboard", path: "/sph/app/accounting" }],
      }}
      title={
        <Box display="flex">
          <Box flexGrow={1}>Imaging</Box>
          <Box>
            <Paper>
              <Tabs
                value={category}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="on"
              >
                <Tab value="test-person" label="Test Person" />
                <Tab value="sales" label="Sales" />
                <Tab value="test" label="Imaging Test" />
              </Tabs>
            </Paper>
          </Box>
        </Box>
      }
    >
      <Box>
        <TabPanel value={category} index="test-person">
          <Paper>
            <TestPerson />
          </Paper>
        </TabPanel>
        <TabPanel value={category} index="sales">
          <ImagingSales />
        </TabPanel>
        <TabPanel value={category} index="test">
          <ImagingTest />
        </TabPanel>
      </Box>
    </Container>
  );
};

export default AccountingImaging;
